import * as actionTypes from "~/store/action_types";
import { mergeEntities } from "~/utils/reduxUtils";

const discussions = (state = {}, action) => {
  switch (action.type) {
    case actionTypes.ADD_COMMENT_LOADING: {
      if (!action.parentId || action.parentType !== "Discussion" || !state[action.parentId]) {
        return state;
      }
      const previous = state[action.parentId] || {};
      const { comments_count = 0 } = previous;
      return {
        ...state,
        [action.parentId]: {
          ...previous,
          comments_count: comments_count ? comments_count + 1 : 1,
        },
      };
    }
    case actionTypes.MOVE_COMMENT_TO_TRASH_SUCCESS: {
      if (!action.parentId || action.parentType !== "Discussion" || !state[action.parentId]) {
        return state;
      }
      const previous = state[action.parentId] || {};
      const { comments_count = 0 } = previous;
      return {
        ...state,
        [action.parentId]: {
          ...previous,
          comments_count: comments_count > 0 ? comments_count - 1 : 0,
        },
      };
    }
    case actionTypes.FETCH_DISCUSSIONS_SUCCESS:
    case actionTypes.FETCH_DISCUSSION_SUCCESS:
    case actionTypes.PREFETCH_DISCUSSION_SUCCESS:
    case actionTypes.FETCH_ACTIVITY_LOGS_SUCCESS:
    case actionTypes.ADD_DISCUSSION_SUCCESS:
    case actionTypes.FETCH_ATTACHMENTS_SUCCESS:
    case actionTypes.FETCH_FILES_AND_ATTACHMENTS_SUCCESS:
    case actionTypes.ADD_DISCUSSION_FROM_EVENT_STREAM:
    case actionTypes.PROJECT_TEMPLATE_APPLY_SUCCESS: {
      const { response = {} } = action;
      const { entities = {} } = response;
      return mergeEntities(state, entities.discussions);
    }
    case actionTypes.EMPTY_DISCUSSIONS:
      return {};
    case actionTypes.EDIT_DISCUSSION_SUCCESS: {
      const { response } = action;
      const { result } = response;
      const discussionId = action.response.result.single;
      const editedDiscussion = action.response.entities.discussions[discussionId];
      return {
        ...state,
        [result.single]: {
          ...state[`${result.single}`],
          ...editedDiscussion,
        },
      };
    }
    case actionTypes.RESTORE_DISCUSSION_FROM_TRASH_SUCCESS:
    case actionTypes.MOVE_DISCUSSION_TO_TRASH_SUCCESS: {
      if (!action.objectType || action.objectType !== `Discussion` || !action.id || !state[action.id]) {
        return state;
      }
      const { response = {} } = action;
      const { entities = {}, result = {} } = response;
      const { single } = result;
      const { discussions = {} } = entities;

      const discussion = discussions[single];

      if (discussion) {
        return {
          ...state,
          [single]: discussion,
        };
      }

      return state;
    }
    case actionTypes.RESTORE_DISCUSSION_FROM_TRASH_FROM_EVENT_STREAM:
    case actionTypes.MOVE_DISCUSSION_TO_TRASH_FROM_EVENT_STREAM: {
      const { response = {} } = action;
      const { entities = {}, result = 0 } = response;
      const { discussions = {} } = entities;

      const discussion = discussions[result];

      if (discussion) {
        return {
          ...state,
          [result]: discussion,
        };
      }

      return state;
    }
    case actionTypes.UPDATE_DISCUSSION_FROM_EVENT_STREAM:
    case actionTypes.DISCUSSION_MOVED_TO_PROJECT_FROM_EVENT_STREAM: {
      const { response = {} } = action;
      const { entities = {}, result: discussionId } = response;
      const { discussions = {} } = entities;

      const data = discussions[`${discussionId}`];

      if (data) {
        return {
          ...state,
          [discussionId]: state[`${discussionId}`] ? { ...state[`${discussionId}`], ...data } : data,
        };
      }

      return state;
    }
    case actionTypes.CONVERT_DISCUSSION_TO_TASK_SUCCESS: {
      if (state[action.discussionId]) {
        const { [action.discussionId]: value, ...rest } = state;
        return rest;
      }
      return state;
    }
    case actionTypes.DATA_OBJECT_DELETED_SUCCESS: {
      if (action.objectType === "Discussion" && state[action.id]) {
        const { [action.id]: value, ...rest } = state;
        return rest;
      }

      return state;
    }
    case actionTypes.MOVE_DISCUSSION_TO_PROJECT_SUCCESS: {
      const { projectId = 0, newProjectId = 0, response = {} } = action;
      const { entities = {}, result = {} } = response;
      const { discussions = {} } = entities;
      const { single: id = 0 } = result;

      const discussion = discussions[id] ?? {};

      if (id && projectId !== newProjectId) {
        return { ...state, [id]: discussion };
      }
      return state;
    }
    case actionTypes.FETCH_CALENDAR_ASSIGMENTS_SUCCESS: {
      const { response = {} } = action;
      const { entities = {} } = response;
      const { discussions } = entities;

      if (!discussions) {
        return state;
      }

      return mergeEntities(state, discussions);
    }
    default:
      return state;
  }
};

export default discussions;
